import * as ServiceWithSegments from './ServiceWithSegments.module.css';

export default {
	ServiceWithSegments
};
